import ConfirmationDialog from 'components/ReusableComponents/ConfirmationDialog'
import HolidayIcon from 'components/ReusableComponents/Icons/Holiday'
import moment from 'moment'
import { useState } from 'react'
import canadianProvinces from 'static/addresses/canadianProvinces'
import usStates from 'static/addresses/usStates'

import styles from './RestrictedDateWarning.module.scss'

const RestrictedDateWarningCampaigns = ({ restrictedTextingDates }) => {
  const nextRestrictedTextingDate = restrictedTextingDates[0]

  const { name, date, states, provinces } = nextRestrictedTextingDate || {}

  const [isShowMoreDialogVisible, setIsShowMoreDialogVisible] = useState(false)

  return (
    <>
      {isShowMoreDialogVisible && (
        <ConfirmationDialog
          title="Upcoming holidays"
          onClose={() => setIsShowMoreDialogVisible(false)}
          theme="blacklist"
        >
          <div className={styles.dialogContent}>
            {restrictedTextingDates.map(({ name, date, states, provinces }, index) => (
              <div key={index} className={styles.dialogItem}>
                <div className={styles.dialogItemTextHolder}>
                  <p className={styles.dialogItemTitle}>{name}</p>
                  <p className={styles.dialogItemDescription}>
                    {moment(date).format('MMMM D, YYYY')}
                  </p>
                  <p className={styles.dialogItemDescription}>
                    {states.includes('National') &&
                      provinces.includes('National') &&
                      'US and Canada'}
                    {states.includes('National') &&
                      !provinces.includes('National') &&
                      'US National'}
                    {!states.includes('National') &&
                      provinces.includes('National') &&
                      'Canada National'}
                    {!states.includes('National') &&
                      !provinces.includes('National') &&
                      [...states, ...provinces]
                        .map(
                          stateOrProvince =>
                            ({ ...usStates, ...canadianProvinces }[stateOrProvince])
                        )
                        .join(', ')}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </ConfirmationDialog>
      )}
      <div className={styles.bar}>
        <div className={styles.iconHolder}>
          <HolidayIcon />
        </div>
        <div className={styles.textHolder}>
          <p className={styles.title}>Upcoming holiday: {name}</p>
          <p className={styles.description}>
            We won't reach guests in{' '}
            {states.includes('National') &&
              provinces.includes('National') &&
              'US and Canada'}
            {states.includes('National') && !provinces.includes('National') && 'US'}
            {!states.includes('National') && provinces.includes('National') && 'Canada'}
            {!states.includes('National') &&
              !provinces.includes('National') &&
              [...states, ...provinces]
                .map(
                  stateOrProvince =>
                    ({ ...usStates, ...canadianProvinces }[stateOrProvince])
                )
                .join(', ')}{' '}
            on {moment(date).format('MMM DD')}.{' '}
            {restrictedTextingDates.length > 1 && (
              <span
                className={styles.showMore}
                onClick={() => setIsShowMoreDialogVisible(true)}
              >
                Show more holidays
              </span>
            )}
          </p>
        </div>
      </div>
    </>
  )
}

export default RestrictedDateWarningCampaigns
